import { takeLatest, select,put, call } from "redux-saga/effects";
import axios from "axios";
import { saveAs } from "file-saver";
import log from "loglevel";
import messages from '../../assets/i18n';

import getEnvParam from "../../utils/getEnvParam";

const requestPDF = (pedido, enterpriseName, token, lang) => {
    // TODO Esse enterpriseName paramentro default deve trazer nome empresa, para isso servico deve ser alterado. 
    enterpriseName = enterpriseName.toLowerCase();
    
    return new Promise((resolve, reject) => {
        if(!pedido){
            reject("Pedido nulo.")
        }
        return axios.request(getEnvParam("REACT_APP_BFF_URL_REST") + "/report/relatorio/Reports/"+enterpriseName+"_pedido.pdf?idPedido="+pedido+"&userLocale="+lang, {
            method: 'GET',
            headers: {
                "Content-Type": "application/json",
                "NPF_ROUTE": getEnvParam("REACT_APP_HEADER_REPORT"),
                "Authorization": token
            },
            responseType: 'blob'
            })
            .then(response => response.status !== 200 ? reject(response) : response)
            .then(response => response.data)
            .then(response => resolve(response))
            .catch(error => {
                reject(error);
                log.info(error);
            });
    });
};

function* postUsersFromApi({payload}) {
    try {
        yield put({ type: "SET_REPORT_LOADING", payload: true });

        const { token } = yield select(state => state.authentication);
        
        const lang = yield select(state => state.language.name);
        const langValue = lang.replace('-', '_');

        let data = yield call(requestPDF, payload.pedido, payload.enterpriseName, token, langValue);
        saveAs(data, messages[lang].reportOrder + `_${payload.pedido}.pdf`);
        yield put({ type: "POST_USERS_FROM_API", pdf: data });

        yield put({ type: "SET_REPORT_LOADING", payload: false });
    } catch (error) {
        log.info(error);
    }
}

export function* getReport() {
    yield takeLatest("GET_REPORT", postUsersFromApi);
}
